import React, { useCallback, useState } from 'react'
import { useDispatch, useSelector } from 'hooks/use-redux'
import { useNavigate } from 'react-router-dom'
import { cancelScheduledCampaign } from '@disco/state-management/actions/campaign-details-actions'
import { getCampaign } from '@disco/state-management/selectors/campaigns'
import ModalDialog from 'components/ui/modal-dialog'

const EditScheduledEmailModal = ({
  campaignId,
}: {
  campaignId: string
}): React.ReactNode => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const campaign = useSelector(state =>
    getCampaign(state, {
      campaignId: Number(campaignId),
    }),
  )
  const [canceling, setCanceling] = useState(false)
  const onCancel = useCallback(() => {
    navigate(`/campaigns/${campaignId}/confirm`)
  }, [campaignId, navigate])
  const onClick = useCallback(async () => {
    setCanceling(true)

    try {
      await dispatch(cancelScheduledCampaign(Number(campaignId)))
    } catch (_) {}

    setCanceling(false)
  }, [campaignId])
  if (!campaign.scheduled_at) return null
  return (
    <ModalDialog
      title="This email is already scheduled"
      primaryAction={{
        caption: 'Let me edit',
        onClick,
        progressCaption: 'Loading',
        progressIndicator: canceling,
      }}
      status="warning"
      onCancel={onCancel}
    >
      Editing the email will cancel the scheduling. Please make sure to
      reschedule when you are done.
    </ModalDialog>
  )
}

export default EditScheduledEmailModal
